export const STONE_NAV = [
  { slug: "blue-sapphire", name: "Blue Sapphire", hindi: "Neelam" },
  { slug: "yellow-sapphire", name: "Yellow Sapphire", hindi: "Pukhraj" },
  { slug: "ruby", name: "Ruby", hindi: "Manik" },
  { slug: "emerald", name: "Emerald", hindi: "Panna" },
  { slug: "red-coral", name: "Red Coral", hindi: "Moonga" },
  { slug: "pearl", name: "Pearl", hindi: "Moti" },
  { slug: "hessonite", name: "Hessonite", hindi: "Gomed" },
  { slug: "cats-eye", name: "Cat's Eye", hindi: "Lehsunia" },
  { slug: "white-sapphire", name: "White Sapphire", hindi: "Safed Pukhraj" },
];

export const PLANET_NAV = [
  { slug: "sun", label: "Sun · Ruby" },
  { slug: "moon", label: "Moon · Pearl" },
  { slug: "mangal", label: "Mangal · Red Coral" },
  { slug: "budh", label: "Budh · Emerald" },
  { slug: "guru", label: "Guru · Yellow Sapphire" },
  { slug: "shukra", label: "Shukra · White Sapphire" },
  { slug: "shani", label: "Shani · Blue Sapphire" },
  { slug: "rahu", label: "Rahu · Hessonite" },
  { slug: "ketu", label: "Ketu · Cat's Eye" },
];

export const INTENT_NAV = [
  { slug: "wealth-abundance", label: "Wealth & abundance" },
  { slug: "protection", label: "Protection" },
  { slug: "clarity-focus", label: "Clarity & focus" },
  { slug: "relationships", label: "Relationships" },
  { slug: "career-work", label: "Career & work" },
  { slug: "study-learning", label: "Study & learning" },
  { slug: "peace-of-mind", label: "Peace of mind" },
];

export const BUDGET_NAV = [
  { slug: "under-5000", label: "Under ₹5,000" },
  { slug: "5000-25000", label: "₹5,000 – ₹25,000" },
  { slug: "25000-100000", label: "₹25,000 – ₹1,00,000" },
  { slug: "above-100000", label: "Above ₹1,00,000" },
];

export const CATEGORY_NAV = [
  { to: "/shop/gemstones", label: "Gemstones" },
  { to: "/shop/rudraksha", label: "Rudraksha" },
  { to: "/shop/malas", label: "Malas & kanthas" },
  { to: "/shop/bracelets", label: "Bracelets" },
  { to: "/shop/pendants", label: "Pendants & rings" },
  { to: "/shop/yantras", label: "Yantras" },
  { to: "/collection/semi-precious", label: "Semi-precious collection" },
  { to: "/shop/new", label: "New arrivals" },
  { to: "/shop/sold-archive", label: "Sold archive" },
];

export const MUKHI_NAV = [1, 2, 3, 4, 5, 6, 7, 11, 14];

export const RASHI_NAV = [
  { slug: "mesha", label: "Mesha · Aries" },
  { slug: "vrishabha", label: "Vrishabha · Taurus" },
  { slug: "mithuna", label: "Mithuna · Gemini" },
  { slug: "karka", label: "Karka · Cancer" },
  { slug: "simha", label: "Simha · Leo" },
  { slug: "kanya", label: "Kanya · Virgo" },
  { slug: "tula", label: "Tula · Libra" },
  { slug: "vrishchika", label: "Vrishchika · Scorpio" },
  { slug: "dhanu", label: "Dhanu · Sagittarius" },
  { slug: "makara", label: "Makara · Capricorn" },
  { slug: "kumbha", label: "Kumbha · Aquarius" },
  { slug: "meena", label: "Meena · Pisces" },
];

export const CONSULT_NAV = [
  { to: "/consult/suitability-session", label: "The Proof-First Session", price: "₹499" },
  { to: "/consult/vedic-astrology", label: "The Full Chart Session", price: "₹3,500" },
  { to: "/consult/numerology", label: "The Number Check", price: "₹3,500" },
  { to: "/consult/name-decision", label: "The Naming Decision", price: "₹11,000" },
  { to: "/consult/muhurat", label: "The Right-Date Session", price: "₹5,100" },
  { to: "/consult/annual-plan", label: "The Standing Appointment", price: "₹25,000/year" },
  { to: "/consult/puja", label: "Puja & Anushthan", price: "Per rite" },
];

export const TOOLS_NAV = [
  { to: "/tools/verify-a-certificate", label: "Verify a certificate", note: "Works on any seller's report number" },
  { to: "/tools/rudraksha-finder", label: "Rudraksha Finder", note: "Priced by mukhi, never by size" },
  { to: "/tools/carat-ratti-converter", label: "Carat–Ratti Converter", note: "With the factor stated" },
  { to: "/tools/numerology-calculator", label: "Numerology Calculator", note: "Free, and always will be" },
  { to: "/tools/free-kundli", label: "Free Kundli", note: "Declined for under-18s" },
  { to: "/tools/muhurat-calendar", label: "Muhurat Calendar", note: "Festival and auspicious dates" },
];

export const LEGAL_NAV = [
  { to: "/legal/terms", label: "Terms" },
  { to: "/legal/privacy", label: "Privacy" },
  { to: "/legal/consent-notice", label: "Consent notice" },
  { to: "/legal/refunds", label: "Returns & refunds" },
  { to: "/legal/shipping", label: "Shipping" },
  { to: "/legal/disclaimer", label: "Disclaimer" },
  { to: "/legal/scope-of-practice", label: "Scope of practice" },
  { to: "/legal/crisis-policy", label: "Crisis policy" },
  { to: "/legal/grievance", label: "Grievance officer" },
  { to: "/legal/consumer-redressal", label: "Consumer redressal" },
  { to: "/legal/cookies", label: "Cookies" },
  { to: "/legal/pricing-and-payments", label: "Pricing & payments" },
];

/* Navgraha detail for the quick-nav grid. Stones follow the classical scheme
   already used by the catalogue. */
export const GRAHA_DETAIL = [
  { slug: "sun", deva: "सूर्य", name: "Surya", english: "Sun", stone: "Ruby", stone_slug: "ruby" },
  { slug: "moon", deva: "चन्द्र", name: "Chandra", english: "Moon", stone: "Pearl", stone_slug: "pearl" },
  { slug: "mangal", deva: "मंगल", name: "Mangal", english: "Mars", stone: "Red Coral", stone_slug: "red-coral" },
  { slug: "budh", deva: "बुध", name: "Budh", english: "Mercury", stone: "Emerald", stone_slug: "emerald" },
  { slug: "guru", deva: "गुरु", name: "Guru", english: "Jupiter", stone: "Yellow Sapphire", stone_slug: "yellow-sapphire" },
  { slug: "shukra", deva: "शुक्र", name: "Shukra", english: "Venus", stone: "White Sapphire", stone_slug: "white-sapphire" },
  { slug: "shani", deva: "शनि", name: "Shani", english: "Saturn", stone: "Blue Sapphire", stone_slug: "blue-sapphire" },
  { slug: "rahu", deva: "राहु", name: "Rahu", english: "North node", stone: "Hessonite", stone_slug: "hessonite" },
  { slug: "ketu", deva: "केतु", name: "Ketu", english: "South node", stone: "Cat's Eye", stone_slug: "cats-eye" },
];

export const RASHI_DETAIL = [
  { slug: "mesha", deva: "मेष", name: "Mesha", english: "Aries", symbol: "♈\uFE0E", stone: "Red Coral" },
  { slug: "vrishabha", deva: "वृषभ", name: "Vrishabha", english: "Taurus", symbol: "♉\uFE0E", stone: "White Sapphire" },
  { slug: "mithuna", deva: "मिथुन", name: "Mithuna", english: "Gemini", symbol: "♊\uFE0E", stone: "Emerald" },
  { slug: "karka", deva: "कर्क", name: "Karka", english: "Cancer", symbol: "♋\uFE0E", stone: "Pearl" },
  { slug: "simha", deva: "सिंह", name: "Simha", english: "Leo", symbol: "♌\uFE0E", stone: "Ruby" },
  { slug: "kanya", deva: "कन्या", name: "Kanya", english: "Virgo", symbol: "♍\uFE0E", stone: "Emerald" },
  { slug: "tula", deva: "तुला", name: "Tula", english: "Libra", symbol: "♎\uFE0E", stone: "White Sapphire" },
  { slug: "vrishchika", deva: "वृश्चिक", name: "Vrishchika", english: "Scorpio", symbol: "♏\uFE0E", stone: "Red Coral" },
  { slug: "dhanu", deva: "धनु", name: "Dhanu", english: "Sagittarius", symbol: "♐\uFE0E", stone: "Yellow Sapphire" },
  { slug: "makara", deva: "मकर", name: "Makara", english: "Capricorn", symbol: "♑\uFE0E", stone: "Blue Sapphire" },
  { slug: "kumbha", deva: "कुम्भ", name: "Kumbha", english: "Aquarius", symbol: "♒\uFE0E", stone: "Blue Sapphire" },
  { slug: "meena", deva: "मीन", name: "Meena", english: "Pisces", symbol: "♓\uFE0E", stone: "Yellow Sapphire" },
];

/* Devanagari names, for the second line on a product card. */
export const STONE_DEVA = {
  "blue-sapphire": "नीलम",
  "yellow-sapphire": "पुखराज",
  ruby: "माणिक",
  emerald: "पन्ना",
  "red-coral": "मूंगा",
  pearl: "मोती",
  hessonite: "गोमेद",
  "cats-eye": "लहसुनिया",
  "white-sapphire": "सफ़ेद पुखराज",
};

export const TYPE_DEVA = {
  rudraksha: "रुद्राक्ष",
  mala: "माला",
  bracelet: "कंगन",
  pendant: "अंगूठी",
  yantra: "यंत्र",
};

export const SOCIAL = [
  { label: "Instagram", key: "instagram", url: "" },
  { label: "YouTube", key: "youtube", url: "" },
  { label: "Facebook", key: "facebook", url: "" },
  { label: "WhatsApp", key: "whatsapp", url: "" },
];

export const PAYMENT_BADGES = ["Visa", "Mastercard", "Amex", "UPI", "Net banking"];

/* Rudraksha mukhi detail. Deity and graha associations are traditional
   attributions, stated as tradition rather than as effect. */
export const MUKHI_DETAIL = [
  { mukhi: 1, deva: "एकमुखी", name: "Ek mukhi", deity: "Shiva", graha: "Sun", to: "/shop/rudraksha/1-mukhi" },
  { mukhi: 2, deva: "द्विमुखी", name: "Do mukhi", deity: "Ardhanarishvara", graha: "Moon", to: "/shop/rudraksha/2-mukhi" },
  { mukhi: 3, deva: "त्रिमुखी", name: "Teen mukhi", deity: "Agni", graha: "Mars", to: "/shop/rudraksha/3-mukhi" },
  { mukhi: 4, deva: "चतुर्मुखी", name: "Char mukhi", deity: "Brahma", graha: "Mercury", to: "/shop/rudraksha/4-mukhi" },
  { mukhi: 5, deva: "पंचमुखी", name: "Panch mukhi", deity: "Kalagni Rudra", graha: "Jupiter", to: "/shop/rudraksha/5-mukhi" },
  { mukhi: 6, deva: "षण्मुखी", name: "Chhah mukhi", deity: "Kartikeya", graha: "Venus", to: "/shop/rudraksha/6-mukhi" },
  { mukhi: 7, deva: "सप्तमुखी", name: "Saat mukhi", deity: "Mahalakshmi", graha: "Saturn", to: "/shop/rudraksha/7-mukhi" },
  { mukhi: 8, deva: "अष्टमुखी", name: "Aath mukhi", deity: "Ganesha", graha: "Rahu", to: "/shop/rudraksha/8-mukhi" },
  { mukhi: 9, deva: "नवमुखी", name: "Nau mukhi", deity: "Durga", graha: "Ketu", to: "/shop/rudraksha/9-mukhi" },
  { mukhi: 10, deva: "दशमुखी", name: "Das mukhi", deity: "Vishnu", graha: "All nine", to: "/shop/rudraksha/10-mukhi" },
  { mukhi: 11, deva: "एकादशमुखी", name: "Gyarah mukhi", deity: "Hanuman", graha: "All nine", to: "/shop/rudraksha/11-mukhi" },
  { mukhi: 12, deva: "द्वादशमुखी", name: "Barah mukhi", deity: "Surya", graha: "Sun", to: "/shop/rudraksha/12-mukhi" },
  { mukhi: 13, deva: "त्रयोदशमुखी", name: "Terah mukhi", deity: "Indra & Kamadeva", graha: "Venus", to: "/shop/rudraksha/13-mukhi" },
  { mukhi: 14, deva: "चतुर्दशमुखी", name: "Chaudah mukhi", deity: "Hanuman", graha: "Saturn", to: "/shop/rudraksha/14-mukhi" },
];

export const MUKHI_SPECIALS = [
  { slug: "gauri-shankar", deva: "गौरी शंकर", name: "Gauri Shankar", deity: "Shiva & Parvati", graha: "Moon", to: "/shop/rudraksha?q=Gauri%20Shankar" },
  { slug: "ganesh", deva: "गणेश", name: "Ganesh", deity: "Ganesha", graha: "Mercury", to: "/shop/rudraksha?q=Ganesh" },
  { slug: "trijuti", deva: "त्रिजुटी", name: "Trijuti", deity: "Brahma, Vishnu & Shiva", graha: "Jupiter", to: "/shop/rudraksha?q=Trijuti" },
  { slug: "sawar", deva: "सावर", name: "Sawar", deity: "Shiva & Parvati", graha: "Moon", to: "/shop/rudraksha?q=Sawar" },
];

export const COMPANY = {
  legal_name: "Shreem Mantra Energy",
  whatsapp: "",
  address: "Registered office details will be published once we complete GST registration.",
  gstin: "Pending — will be published on invoice on registration",
  cin: "Pending",
  phone: "",
  email: "care@shreemmantraenergy.com",
  hours: "10:00 to 18:00 IST, Monday to Saturday",
  grievance_name: "Grievance Officer",
  grievance_designation: "Compliance",
  grievance_email: "grievance@shreemmantraenergy.com",
  grievance_phone: "",
  privacy_email: "privacy@shreemmantraenergy.com",
  founder_name: "",
  founder_email: "",
};
